import { GeoJSON } from 'geojson'

import { Task } from '@/feature/execution-board'

import { useNetworkMutation } from '@/lib/utils/request'

export interface TaskLocationPayload {
  originalObjectId?: number | string | null
  type: string
  name?: string
  address?: string
  geoJson?: GeoJSON
  // Arrival date-time for this stop. Required on the first and last locations;
  // optional for intermediate stops. Replaces the task-level from/to datetimes.
  plannedArrival?: Date
}

export interface CreateTaskPayload extends Record<string, unknown> {
  // Optional fields
  reference?: string
  assignedTo?: number
  description?: string
  // Mandatory fields (marked with *)
  locations: TaskLocationPayload[]
}

export const useCreateTask = () =>
  useNetworkMutation<Task, CreateTaskPayload>({
    url: '/v1/tasks/',
    method: 'post',
  })
